<template>
    <router-link to='/admin/results'>תוצאות</router-link>
</template>